import './LoadingOverlay.css'

interface LoadingOverlayProps {
  visible: boolean
}

export function LoadingOverlay({ visible }: LoadingOverlayProps) {
  if (!visible) return null

  return (
    <div className="loading-overlay">
      <div className="loading-scene">
        <div className="loader-shadow" />

        {/* Wheel Loader */}
        <svg className="dump-truck" viewBox="0 0 180 100" width="180" height="100" fill="none" aria-hidden="true">
          {/* Rear body */}
          <path d="M30 40 L30 65 L80 65 L80 40 Z" stroke="#0a5c36" strokeWidth="3" strokeLinejoin="round" />
          {/* Engine compartment top */}
          <line x1="30" y1="40" x2="55" y2="35" stroke="#0a5c36" strokeWidth="3" />
          <line x1="55" y1="35" x2="55" y2="40" stroke="#0a5c36" strokeWidth="2" />
          {/* Cab */}
          <path d="M55 25 L55 65 L85 65 L85 30 L72 25 Z" stroke="#0a5c36" strokeWidth="3" strokeLinejoin="round" />
          {/* Cab window */}
          <rect x="60" y="28" width="12" height="15" rx="1" stroke="#0a5c36" strokeWidth="2" />
          {/* Articulation joint */}
          <circle cx="85" cy="55" r="3" fill="#0a5c36" />
          {/* Front body */}
          <path d="M85 45 L85 65 L115 65 L115 45 Z" stroke="#0a5c36" strokeWidth="3" strokeLinejoin="round" />
          {/* Lift arm (upper) */}
          <line x1="95" y1="45" x2="140" y2="42" stroke="#0a5c36" strokeWidth="3" strokeLinecap="round" />
          {/* Lift arm (lower) */}
          <line x1="100" y1="55" x2="140" y2="52" stroke="#0a5c36" strokeWidth="3" strokeLinecap="round" />
          {/* Hydraulic cylinder */}
          <line x1="90" y1="38" x2="110" y2="42" stroke="#0a5c36" strokeWidth="2" strokeLinecap="round" />
          {/* Bucket */}
          <path d="M136 34 L162 34 L170 62 L138 58 Z" stroke="#0a5c36" strokeWidth="3" strokeLinejoin="round" className="bucket" />
          {/* Bucket teeth */}
          <line x1="144" y1="34" x2="143" y2="28" stroke="#0a5c36" strokeWidth="2" />
          <line x1="152" y1="34" x2="151" y2="28" stroke="#0a5c36" strokeWidth="2" />
          <line x1="160" y1="34" x2="159" y2="28" stroke="#0a5c36" strokeWidth="2" />
          {/* Exhaust stack */}
          <rect x="35" y="30" width="4" height="10" stroke="#0a5c36" strokeWidth="2" />
          {/* Exhaust puffs */}
          <circle className="puff puff-1" cx="37" cy="26" r="3" stroke="#0a5c36" strokeWidth="1.5" />
          <circle className="puff puff-2" cx="35" cy="20" r="2.5" stroke="#0a5c36" strokeWidth="1.5" />
          <circle className="puff puff-3" cx="39" cy="15" r="2" stroke="#0a5c36" strokeWidth="1" />
          {/* Rear wheel (large) */}
          <circle cx="55" cy="78" r="14" stroke="#0a5c36" strokeWidth="3" />
          <circle cx="55" cy="78" r="5" fill="#0a5c36" />
          {/* Rear tire tread marks */}
          <circle className="wheel-tread rear-tread" cx="55" cy="78" r="10" stroke="#0a5c36" strokeWidth="1" strokeDasharray="4 3" />
          {/* Front wheel (large) */}
          <circle cx="105" cy="78" r="14" stroke="#0a5c36" strokeWidth="3" />
          <circle cx="105" cy="78" r="5" fill="#0a5c36" />
          {/* Front tire tread marks */}
          <circle className="wheel-tread front-tread" cx="105" cy="78" r="10" stroke="#0a5c36" strokeWidth="1" strokeDasharray="4 3" />
          {/* Orbiting green quarter-circle around rear wheel */}
          <g className="orbit">
            <path className="orbit-arc" d="M55 60 A18 18 0 0 1 73 78" stroke="#22c55e" strokeWidth="4" strokeLinecap="round" fill="none" />
          </g>
        </svg>

        <div className="hm-block" aria-hidden="true">
          <span className="hm-block-text">HM</span>
        </div>

        {/* Ground (scrolling) */}
        <div className="ground">
          <div className="ground-line" />
        </div>
      </div>

      <p className="loading-text">Loading...</p>
    </div>
  )
}
